import { Timestamp } from '@angular/fire/firestore';

export class FireTimestamp {
  constructor(seconds: number, nanoseconds: number) {
    this.seconds = seconds;
    this.nanoseconds = nanoseconds;
  }
  seconds: number;
  nanoseconds: number;
  toDate(): Date {
    return new Date(this.seconds * 1000 + this.nanoseconds / 1000000);
  }
  static fromDate(date: Date): FireTimestamp {
    return Timestamp.fromDate(date);
  }
}
